import { createFeature, createReducer, on } from '@ngrx/store';
import { WorkflowActions } from './workflow.actions';

export interface WorkflowState {
  /** Persisted tickets board columns for the warmed project (null = not loaded). */
  board: any[] | null;
  loadedAtMs: number | null;
}

const initialState: WorkflowState = {
  board: null,
  loadedAtMs: null,
};

export const workflowFeature = createFeature({
  name: 'workflow',
  reducer: createReducer(
    initialState,
    on(WorkflowActions.boardLoaded, (s, { columns }): WorkflowState => ({
      ...s,
      board: Array.isArray(columns) ? columns : [],
      loadedAtMs: Date.now(),
    }))
  ),
});
